'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var index = 0;

exports.default = {
  generate: function generate() {
    return 'mui-id-' + index++;
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/lib/utils/unique-id.js
// module id = XiX0
// module chunks = 0